import ReactModal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import BasicButton from "components/button/BasicButton";
import { sendGet, sendPost, sendPostFile } from "api/restUtil";
import FileUpload from "components/input/FileUpload";
import BasicInput from "components/input/BasicInput";
import SmartEditor from "components/SmartEditor";
import Float from "components/input/Float";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import SupplementProductDisplay from "./SupplementProductDisplay";
import SupplementProductAddModModal from "./SupplementProductAddModModal";
import { delConfirm, getEditorContent } from "js/common";
import BasicSelect from "components/input/BasicSelect";

/**
 * 상품 추가/수정 팝업
 */
function ProductAddModModal (props) {

	const { isOpen, onClose, initData, returnData, modalId, title } = props;
	const [ data, setData ] = useState({})
	const [ mode, setMode ] = useState("add");
	const [ modInitData, setModInitData ] = useState([]);
	const categoryTagSelect = useRef();
	// const [ repImgUrl, setRepImgUrl] = useState("");
	
	const [ isOpenSupplementProductAddModal, setIsOpenSupplementProductAddModal ] = useState(false);
	const [ isOpenSupplementProductModModal, setIsOpenSupplementProductModModal ] = useState(false);

	const onClickOk = () => {
		const requiredColumns = ["originProduct.name"
							, "originProduct.statusType"
							, "originProduct.salePrice"
							, "originProduct.deliveryInfo.deliveryType"
							, "originProduct.deliveryInfo.deliveryAttributeType"
							, "originProduct.deliveryInfo.deliveryFee.deliveryFeeType"
							, "originProduct.deliveryInfo.deliveryFee.deliveryFeePayType"
							, "originProduct.deliveryInfo.claimDeliveryInfo.returnDeliveryFee"
							, "originProduct.deliveryInfo.claimDeliveryInfo.exchangeDeliveryFee"
							, "originProduct.detailAttribute.afterServiceInfo.afterServiceTelephoneNumber"
							, "originProduct.detailAttribute.afterServiceInfo.afterServiceGuideContent"
							, "originProduct.detailAttribute.originAreaInfo.originAreaCode"
							, "originProduct.detailAttribute.taxType"
							, "originProduct.detailAttribute.minorPurchasable"
							, "originProduct.detailAttribute.productInfoProvidedNotice.etc.customerServicePhoneNumber"
						];
						
						if(mode === "add") {
							requiredColumns.push("originProduct.stockQuantity");	// 등록일때는 재고 필수
						}
		if(data?.originProduct?.deliveryInfo?.deliveryType === "DELIVERY") {
			requiredColumns.push("originProduct.deliveryInfo.deliveryCompany");	// 택배 배송이면 택배사 필수
			
		}
		if(data?.originProduct?.deliveryInfo?.deliveryFee?.deliveryFeeType !== "FREE") {
			requiredColumns.push("originProduct.deliveryInfo.deliveryFee.baseFee");	// 무료가 아니면 기본 배송비 필수
		}
		if(data?.originProduct?.deliveryInfo?.deliveryFee?.deliveryFeeType === "CONDITIONAL_FREE") {
			// 조건부 무료
			requiredColumns.push("originProduct.deliveryInfo.deliveryFee.freeConditionalAmount");	// 무료 조건 금액
		}
		if(data?.originProduct?.detailAttribute?.originAreaInfo?.originAreaCode == "02") {
			requiredColumns.push("originProduct.detailAttribute.originAreaInfo.importer");	// 원산지가 수입산인 경우 수입사 필수
		}
		if(data?.originProduct?.detailAttribute?.originAreaInfo?.originAreaCode == "04") {
			requiredColumns.push("originProduct.detailAttribute.originAreaInfo.content");	// 원산지가 기타-직접입력인 경우 상세 설명 필수
		}
		if(data?.originProduct?.detailAttribute?.supplementProductInfo?.supplementProducts != null && data?.originProduct?.detailAttribute?.supplementProductInfo?.supplementProducts.length > 0) {
			// 추가 상품이 있으면 정렬 방식 필수
			requiredColumns.push("originProduct.detailAttribute.supplementProductInfo.sortType");
		}
		// if(data?.originProduct?.customerBenefit?.immediateDiscountPolicy?.discountMethod?.value != null && data?.originProduct?.customerBenefit?.immediateDiscountPolicy?.discountMethod?.value != "") {
		// 	// 할인 값이 있으면 단위 필수
		// 	requiredColumns.push("originProduct.customerBenefit.immediateDiscountPolicy.discountMethod.unitType");
		// }
		delete data.originProduct.customerBenefit;
		// 필수 체크
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, "#productAddModModal")) return;

		// 상품 설명은 따로
		const detailContent = getEditorContent();
		if(detailContent == null || detailContent === "") {
			alert("상품 설명을 입력해 주세요.");
			return;
		}

		data.originProduct.detailContent = detailContent;

		data.windowChannelProduct = {};
		if(process.env.NODE_ENV === "production") {
			// 운영용
			data.windowChannelProduct.channelNo = 1100007718;
		} else {
			// 알파용 (네이버 개발서버)
			data.windowChannelProduct.channelNo = 102554990;
		}



		if(mode === "mod") {
			data.channelProductNo = initData.channelProductNo;
		}

		returnData(data);
	}
	
	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#productAddModModal");
	}, [data]);

	const handleDataChange = (e) => {
		const {name, value} = e.target;
		let d = {...data};

		let val = value;
		// boolean은 text가 아닌 형태로 형변환
		if(value === "true") val = true;
		else if(value === "false") val = false;

		if(e.target.tagName && e.target.type && e.target.tagName.toLowerCase() === "input" && e.target.type.toLowerCase() === "checkbox") {
			// 체크박스는 선택 여부에 따라서 다르게 처리됨.
			val = Array.from(document.querySelectorAll("#productAddModModal input[type='checkbox'][name=" + e.target.name + "]:checked")).map(obj => obj.value);
		}

		if(name.includes(".")) {
			let nmArr = name.split(".");
			let obj = d;
			for(let i=0; i<nmArr.length; i++) {
				const key = nmArr[i];

				// originProduct.images.optionalImages[0].url
				if(key.includes("[") && key.includes("]")) {
					const tmpKey = key.split("[")[0];
					const tmpIdx = key.split("[")[1].split("]")[0] * 1;
					if(i == nmArr.length - 1) {
						obj[tmpKey][tmpIdx] = val;
					} else {
						if(!obj.hasOwnProperty(tmpKey) || obj[tmpKey] == null) {
							obj[tmpKey] = [];
						}
						if(!obj[tmpKey][tmpIdx]) {
							obj[tmpKey][tmpIdx] = {};
						}
						obj = obj[tmpKey][tmpIdx];
					}
				} else {
					if(i == nmArr.length - 1) {
						obj[key] = val;
					} else {
						if(!obj.hasOwnProperty(key) || obj[key] == null) {
							obj[key] = {};
						}
						obj = obj[key];
					}
				}

			}

		} else {
			d[name] = val;
		}

		setData(d);
	}
	const handleDateClick = (name, value) => {
		let d = {...data};
		d[name] = value;
		setData(d);
	}

	useEffect(() => {

		if(initData.hasOwnProperty("channelProductNo") && initData.channelProductNo != null && initData.channelProductNo !== '') {
			setMode("mod");
			getProductData(initData);
		} else {
			setMode("add");
			setDefaultValue(initData);
			setData(initData);
		}
	}, [initData]);

	// 기본 값 설정
	const setDefaultValue = async (d) => {
		// if(d?.activationYn == null) d.activationYn = true;	//활성화 여부는 기본 값이 있어야 해서 설정
		// if(d?.deliveryYn == null) d.deliveryYn = true;		//현재 배달 가능 여부는 기본 값이 있어야 해서 설정
		// if(d?.pickUpYn == null) d.pickUpYn = true;			//현재 픽업 가능 여부는 기본 값이 있어야 해서 설정
	}

	// 상품 정보 조회
	const getProductData = async (productData) => {
		const result = await sendGet("/api/mgmt/product/" + productData.channelProductNo);
		if(result.respCode == "SUCCESS") {
			setData(result.data);
		} else {
			alert("상품 정보 조회 실패");
			return;
		}
	}
	
	/**
	 * 첨부파일 업로드
	 * @param {*} files 
	 */
	const onFileUpload = async (files, isRepImg) => {

		const result = await sendPostFile("/api/upload-file/product/image", files, "PRODUCT");
		if(result.respCode === "SUCCESS") {
			if(isRepImg) {
				handleDataChange({target: {name: "originProduct.images.representativeImage.url", value: result.data}});
			} else {
				let maxIdx = 0;
				if(data?.originProduct?.images?.optionalImages) {
					maxIdx = data?.originProduct?.images?.optionalImages.length;
				} else {
				}
				handleDataChange({target: {name: "originProduct.images.optionalImages[" + maxIdx + "].url", value: result.data}});
			}
		}
	}
	/**
	 * 대표 이미지 삭제
	 */
	const delRepImage = async () => {
		let d = {...data};
		d.originProduct.images.representativeImage.url = null;
		setData(d);
	}
	const delOptImg = async(idx) => {
		let d = {...data};
		// delete d.originProduct.images.optionalImages[idx];
		d.originProduct.images.optionalImages.splice(idx, 1);
		setData(d);
	}

	/**
	 * 추가상품 등록 팝업
	 */
	const showSupplementProductAddModal = () => {
		setIsOpenSupplementProductAddModal(true);
	}
	/**
	 * 추가 상품 등록 팝업에서 데이터 반환
	 */
	const addSupplementProduct = (supplementData) => {

		if(data?.originProduct?.detailAttribute?.supplementProductInfo?.supplementProducts == null) {
			// 기존에 없으면 새로 넣어줌.
			const tmpEvent = {target: {}};
			tmpEvent.target.name = "originProduct.detailAttribute.supplementProductInfo.supplementProducts";
			tmpEvent.target.value = supplementData;
	
			handleDataChange(tmpEvent);
		} else {
			// 기존에 있으면 추가.
			const newData = {...data};
			let newSupplementProducts = [...newData.originProduct.detailAttribute.supplementProductInfo.supplementProducts];
			newSupplementProducts = [...newSupplementProducts, ...supplementData];
			
			newData.originProduct.detailAttribute.supplementProductInfo.supplementProducts = newSupplementProducts

			setData(newData);
		}

		setIsOpenSupplementProductAddModal(false);
	}

	/**
	 * 추가 상품 수정 팝업
	 */
	const showSupplementProductModModal = (grp) => {
		
		let modData = data.originProduct.detailAttribute.supplementProductInfo.supplementProducts.filter(prd => prd.groupName === grp);
		setModInitData({groupName: grp, list: modData});

		setIsOpenSupplementProductModModal(true);
	}

	/**
	 * 추가 상품 수정 팝업에서 데이터 반환
	 * @param {*} supplementData 
	 */
	const modSupplementProduct = (supplementData) => {

		
		const newData = {...data};
		let newSupplementProducts = [...newData.originProduct.detailAttribute.supplementProductInfo.supplementProducts];
		// 수정한 그룹명을 가지는 첫번째 데이터
		const modDataFirst = newSupplementProducts.find(d => d.groupName === modInitData.groupName);
		// 그 데이터의 인덱스(이 인덱스에 다시 데이터 넣어주기)
		const modDataIdx = newSupplementProducts.indexOf(modDataFirst);

		// 수정한 그룹명을 가지는 데이터 다 제거
		newSupplementProducts = newSupplementProducts.filter(d => d.groupName !== modInitData.groupName);
		// 원래 그 그룹명이 있던 인덱스에 새 데이터 넣어주기
		newSupplementProducts.splice(modDataIdx, 0, ...supplementData);
		
		newData.originProduct.detailAttribute.supplementProductInfo.supplementProducts = newSupplementProducts
		
		setData(newData);

		setIsOpenSupplementProductModModal(false);
	}

	/**
	 * 추가 상품 삭제
	 */
	const delSupplementProduct = (grp) => {
		if(!delConfirm()) {
			return;
		}

		const newData = {...data};
		let newSupplementProducts = newData.originProduct.detailAttribute.supplementProductInfo.supplementProducts;
		newSupplementProducts = newSupplementProducts.filter(prd => prd.groupName !== grp);

		newData.originProduct.detailAttribute.supplementProductInfo.supplementProducts = newSupplementProducts

		setData(newData);
	}

	/**
	 * 추가 상품 그룹명 목록 조회(중복 제거)
	 * @param {*} except 제외할 그룹명 (수정팝업에서 자기거 빼기 위함)
	 * @returns 
	 */
	const getExistsSupplementProductGroupName = (except) => {
		const supplementProducts = data?.originProduct?.detailAttribute?.supplementProductInfo?.supplementProducts;
		
		if(supplementProducts == null || supplementProducts.length == 0) {
			return [];
		}
		if(supplementProducts.length == 1) {
			if(except === supplementProducts[0].groupName) return [];
			else return [supplementProducts[0].groupName];
		}

		return supplementProducts
			.map(prd => prd.groupName)
			.filter(groupName => groupName !== except)
			.reduce((acc, grp) => {
				if(!Array.isArray(acc)) {
					acc = [acc];
				}

				if(!acc.includes(grp)) {
					acc.push(grp);
				}

				return acc;
			});
	}

	// 내부 카테고리 변경시 naver 카테고리 변경
	const [ leafCategorySff, setLeafCategorySff ] = useState([]);
	useEffect(() => {

		const newData = {...data};
		if(!newData.originProduct) {
			newData.originProduct = {};
		}
		if(!newData.originProduct.detailAttribute) {
			newData.originProduct.detailAttribute = {};
		}
		if(!newData.originProduct.detailAttribute.seoInfo) {
			newData.originProduct.detailAttribute.seoInfo = {};
		}
		if(!newData.originProduct.detailAttribute.seoInfo.sellerTags) {
			newData.originProduct.detailAttribute.seoInfo.sellerTags = [{}];
		}
		
		const getLeafCategoryIdNaver = async () => {

			if(leafCategorySff.length === 0) {
				const result = await sendGet("/api/cmn-cd/" + "LEAF_CATEGORY_SFF" );
				if(result.respCode === "SUCCESS") {
					setLeafCategorySff(result.data);

					const tmpLeafCategorySff = result.data;

					const descArr = tmpLeafCategorySff.find(ctg => ctg.cd === data.leafCategoryIdSff).desc.split("|");
					const leafCategoryId = descArr[0];
					const tagId = descArr.length > 1 ? descArr[1] : "";

					newData.originProduct.leafCategoryId = leafCategoryId;
					if(tagId === "") {
						newData.originProduct.detailAttribute.seoInfo = null;
					} else {
						newData.originProduct.detailAttribute.seoInfo.sellerTags[0].code = tagId;
					}
					// newData.originProduct.leafCategoryId = tmpLeafCategorySff.find(ctg => ctg.cd === data.leafCategoryIdSff).desc.split("|")[0];
					setData(newData);
				}
			} else {

				const descArr = leafCategorySff.find(ctg => ctg.cd === data.leafCategoryIdSff).desc.split("|");
				const leafCategoryId = descArr[0];
				const tagId = descArr.length > 1 ? descArr[1] : "";

				newData.originProduct.leafCategoryId = leafCategoryId;
				if(tagId === "") {
					newData.originProduct.detailAttribute.seoInfo = null;
				} else {
					newData.originProduct.detailAttribute.seoInfo.sellerTags[0].code = tagId;
				}

				// newData.originProduct.leafCategoryId = leafCategorySff.find(ctg => ctg.cd === data.leafCategoryIdSff).desc.split("|")[0];
				setData(newData);
			}
		};

		if(data.leafCategoryIdSff != null && data.leafCategoryIdSff !== "") {
			getLeafCategoryIdNaver();
		} else {

				newData.originProduct.leafCategoryId = "";
				newData.originProduct.detailAttribute.seoInfo = null;
				setData(newData);

		}
	}, [data.leafCategoryIdSff]);

	useEffect(() => {
		if(data?.originProduct?.detailAttribute?.seoInfo?.sellerTags?.[0]?.code) {
			// 목록에서 레이블 텍스트 설정
			data.originProduct.detailAttribute.seoInfo.sellerTags[0].text = categoryTagSelect.current.options[categoryTagSelect.current.selectedIndex].text
		} else {
			if(data?.originProduct?.detailAttribute?.seoInfo?.sellerTags?.[0]?.text) {
				data.originProduct.detailAttribute.seoInfo.sellerTags[0].text = null;
			}
		}

	}, [data?.originProduct?.detailAttribute?.seoInfo?.sellerTags?.[0]?.code]);



	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={title + "팝업"}
			id={modalId}
		>
			<div className="me-modal">
				<div className="me-modal-container" style={{width: "1000px", height: "600px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">{title}</h4>
						</div>

						<div className="me-modal-body" style={{overflowY: "scroll"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="body-area modal-form" id="productAddModModal">
								<h2>상품</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>상품명<span className="burgundy">*</span></th>
											<td>
												<BasicInput item={{col: "originProduct.name"}} value={data?.originProduct?.name} onChange={handleDataChange} width="" textAlign="left" />
											</td>
										</tr>
										<tr>
											<th>상품상태<span className="burgundy">*</span></th>
											<td>
												<select name={"originProduct.statusType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.statusType}>
													<option value="">선택하세요.</option>
													<option value={"SALE"}>판매중</option>
													{mode == "mod"  && (
														<option value={"SUSPENSION"}>판매중지</option>
													)}
												</select>
											</td>
										</tr>
										<tr>
											<th>리프 카테고리<span className="burgundy">*</span></th>
											<td>
												<div style={{display: "inline-block"}}>
												<CommonCodeSelect
													item={{col: "leafCategoryIdSff"}} 
													onChange={handleDataChange} 
													value={data?.leafCategoryIdSff} 
													defaultLabel="선택하세요" 
													grpCd="LEAF_CATEGORY_SFF" 
													width={"150px"}
												/>
												</div>
												<div style={{display: "inline-block", marginLeft: "20px"}}>
													네이버 : 
												</div>
												<div style={{display: "inline-block"}} className="selectNotDisabled">
													<CommonCodeSelect
														item={{col: "originProduct.leafCategoryId", disabled: true}} 
														onChange={handleDataChange} 
														value={data?.originProduct?.leafCategoryId} 
														defaultLabel="선택하세요" 
														grpCd="LEAF_CATEGORY_NAVER" 
														width={"350px"}
													/>
												</div>
												<div style={{display: "inline-block"}} className="selectNotDisabled">
													<CommonCodeSelect
														item={{col: "originProduct.detailAttribute.seoInfo.sellerTags[0].code", disabled: true}} 
														onChange={handleDataChange} 
														value={data?.originProduct?.detailAttribute?.seoInfo?.sellerTags?.[0]?.code} 
														defaultLabel="선택하세요" 
														grpCd="CATEGORY_TAG" 
														width={"150px"} 
														ref={categoryTagSelect}
													/>
												</div>

												{/* <select name={"originProduct.leafCategoryId"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.leafCategoryId}>
													<option value="">선택하세요.</option>
													<option value={"50007344"}>임시</option>
												</select> */}
											</td>
										</tr>
										<tr>
											<th>대표이미지</th>
											<td style={{height: "100px"}}>
												{data?.originProduct?.images?.representativeImage?.url ? (
													<>
														<img src={data?.originProduct?.images?.representativeImage?.url} style={{width: "150px"}} />
														<img src={process.env.PUBLIC_URL + "/assets/images/waste_basket.png"} className="del_file_img" alt="삭제" onClick={() => delRepImage()} />
													</>
												) : (
													<FileUpload returnResult={files => onFileUpload(files, true)}/>
												)}
											</td>
										</tr>
										<tr>
											<th>서브이미지</th>
											<td style={{height: "120px"}}>
												<div >
												{data?.originProduct?.images?.optionalImages && 
													data?.originProduct?.images?.optionalImages.map((d, idx) => 
														<Fragment key={"subImg_" + idx}>
															<img src={d.url} style={{width: "150px"}} />
															<img src={process.env.PUBLIC_URL + "/assets/images/waste_basket.png"} className="del_file_img" alt="삭제" onClick={() => delOptImg(idx)} />
														</Fragment>
													)
												}
												</div>
												{/* 서브 이미지 있는데 개수제한 이내일때. 개수제한은 9개 */}
												{data?.originProduct?.images?.optionalImages && 
													data?.originProduct?.images?.optionalImages.length > 0 &&
													data?.originProduct?.images?.optionalImages.length < 9 && (
													<div style={{height: "50px"}}>
														<FileUpload returnResult={files => onFileUpload(files, false)}/>
													</div>
												)}
												{/* 서브이미지 없을때 표시 - 넣었다가 삭제 */}
												{data?.originProduct?.images?.optionalImages &&
													data?.originProduct?.images?.optionalImages.length === 0 && (
														<FileUpload returnResult={files => onFileUpload(files, false)}/>
												)}
												{/* 서브이미지 없을때 표시 - 아예 없는거.. */}
												{data?.originProduct?.images?.optionalImages ? (<></>) : (
													<FileUpload returnResult={files => onFileUpload(files, false)}/>
												)}
											</td>
										</tr>
										<tr>
											<th>상품 설명<span className="burgundy">*</span></th>
											<td>
												<div style={{width: "100%",  marginTop: "5px"}}>
													{(mode === "add" || (mode === "mod" && data?.originProduct)) && (
													<SmartEditor
														width="100%"
														height="350px"
														// getEditorCont={data => handleDataChange({target: {name: "originProduct.detailContent", value: data}})}
														editorCont={data?.originProduct?.detailContent}
													/>
													)}
												</div>
											</td>
										</tr>
										<tr>
											<th>판매가격<span className="burgundy">*</span></th>
											<td>
												<Float className="basic-input" name={"originProduct.salePrice"} value={data?.originProduct?.salePrice ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} maxVal={999999990} />
												원
												<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 : 999,999,990</span>
											</td>
										</tr>
										{/* <tr>
											<th>할인</th>
											<td>
												아 이거 아닌데.... 이거는 n+1이거나 금액당 인디..
												<select name={"originProduct.customerBenefit.branchBenefit.branchBenefitType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.customerBenefit?.branchBenefit?.branchBenefitType}>
													<option value="">선택하세요.</option>
													<option value={"PLUS_1"}>N+1할인</option>
													<option value={"QUANTITY_IGNORE"}>수량무시할인</option>
												</select>
												<Float className="basic-input" name={"originProduct.customerBenefit.branchBenefit.branchBenefitDiscountContents[0].branchPurchaseOrderValue"} value={data?.originProduct?.customerBenefit?.branchBenefit?.branchBenefitDiscountContents?.[0]?.branchPurchaseOrderValue ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={1} maxVal={10000000 } />
												<select name={"originProduct.customerBenefit.branchBenefit.branchBenefitDiscountContents[0].branchPurchaseOrderUnit"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.customerBenefit?.branchBenefit?.branchBenefitDiscountContents?.[0]?.branchPurchaseOrderUnit}>
													<option value="">선택하세요.</option>
													<option value={"WON"}>원</option>
													<option value={"COUNT"}>개</option>
												</select>
												당
												<Float className="basic-input" name={"originProduct.customerBenefit.branchBenefit.branchBenefitDiscountContents[0].branchPurchaseDiscountValue"} value={data?.originProduct?.customerBenefit?.branchBenefit?.branchBenefitDiscountContents?.[0]?.branchPurchaseDiscountValue ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={1} maxVal={10000000 } />
												<select name={"originProduct.customerBenefit.branchBenefit.branchBenefitDiscountContents[0].branchPurchaseDiscountValueUnit"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.customerBenefit?.branchBenefit?.branchBenefitDiscountContents?.[0]?.branchPurchaseDiscountValueUnit}>
													<option value="">선택하세요.</option>
													<option value={"WON"}>원</option>
													<option value={"PERCENT"}>%</option>
												</select>
												<Float className="basic-input" name={"originProduct.customerBenefit.immediateDiscountPolicy.discountMethod.value"} value={data?.originProduct?.customerBenefit?.immediateDiscountPolicy?.discountMethod?.value ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={1} maxVal={10000000 } />
												<select name={"originProduct.customerBenefit.immediateDiscountPolicy.discountMethod.unitType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.customerBenefit?.immediateDiscountPolicy?.discountMethod?.unitType}>
													<option value="">선택하세요.</option>
													<option value={"WON"}>원</option>
													<option value={"PERCENT"}>%</option>
												</select>

												<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 : 10,000,000 </span>
											</td>
										</tr> */}
										<tr>
											<th>재고수량{mode === "add" && (<span className="burgundy">*</span>)}</th>
											<td>
												<Float className="basic-input" name={"originProduct.stockQuantity"} value={data?.originProduct?.stockQuantity ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} />
												<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 0 입력시 품절 처리</span>
												{mode === "mod" && (
													<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 미 입력시, 기존 값 유지</span>
												)}
											</td>
										</tr>

									</tbody>
								</table>

								<h2>배송</h2><table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>배송 방법 유형 <span className="burgundy">*</span></th>
											<td>
												
												<select name={"originProduct.deliveryInfo.deliveryType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.deliveryInfo?.deliveryType}>
													<option value="">선택하세요.</option>
													<option value={"DELIVERY"}>택배,소포,등기</option>
													{/* <option value={"DIRECT"}>직접배송(화물배달)</option> */}
												</select>
											</td>
										</tr>
										{data?.originProduct?.deliveryInfo?.deliveryType === "DELIVERY" && (
											<tr>
												<th>택배사 코드 <span className="burgundy">*</span></th>
												<td>
													
													<select name={"originProduct.deliveryInfo.deliveryCompany"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.deliveryInfo?.deliveryCompany}>
														<option value="">선택하세요.</option>
														<option value={"SNOWFOXFLOWER"}>스노우폭스플라워개별</option>
													</select>
												</td>
											</tr>
										)}
										<tr>
											<th>배송 속성 타입 <span className="burgundy">*</span></th>
											<td>
												
												<select name={"originProduct.deliveryInfo.deliveryAttributeType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.deliveryInfo?.deliveryAttributeType}>
													<option value="">선택하세요.</option>
													<option value={"QUICK"}>배달</option>
													<option value={"PICKUP"}>픽업</option>
													<option value={"QUICK_PICKUP"}>배달&픽업</option>
												</select>
											</td>
										</tr>
										<tr>
											<th>배송비 타입 <span className="burgundy">*</span></th>
											<td>
												<select name={"originProduct.deliveryInfo.deliveryFee.deliveryFeeType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.deliveryInfo?.deliveryFee?.deliveryFeeType}>
													<option value="">선택하세요.</option>
													{/* <option value={"FREE"}>무료</option>
													<option value={"CONDITIONAL_FREE"}>조건부 무료</option> */}
													<option value={"PAID"}>유료</option>
													{/* <option value={"UNIT_QUANTITY_PAID"}>수량 별</option> */}
													{/* <option value={"RANGE_QUANTITY_PAID"}>구간 별</option> */}
												</select>
											</td>
										</tr>
										<tr>
											<th>기본 배송비 <span className="burgundy">*</span></th>
											<td>
												<Float className="basic-input" name={"originProduct.deliveryInfo.deliveryFee.baseFee"} value={data?.originProduct?.deliveryInfo?.deliveryFee?.baseFee ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} />
												<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 100,000</span>
											</td>
										</tr>
										{data?.originProduct?.deliveryInfo?.deliveryFee?.deliveryFeeType === "CONDITIONAL_FREE" && (
											// 배송비 타입이 조건부 무료인 경우
											<tr>
												<th>무료 조건 금액 <span className="burgundy">*</span></th>
												<td>
													<Float className="basic-input" name={"originProduct.deliveryInfo.deliveryFee.freeConditionalAmount"} value={data?.originProduct?.deliveryInfo?.deliveryFee?.freeConditionalAmount ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} />
													<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 999,999,990</span>
												</td>
											</tr>
										)}
										{/* {data?.originProduct?.deliveryInfo?.deliveryFee?.deliveryFeeType === "UNIT_QUANTITY_PAID" && (
											// 배송비 타입이 수량별인 경우 - 이건 뭐 많고 복잡함..
											<tr>
												<th>기본 배송비 반복 부과 수량 <span className="burgundy">*</span></th>
												<td>
													<Float className="basic-input" name={"originProduct.deliveryInfo.deliveryFee.repeatQuantity"} value={data?.originProduct?.deliveryInfo?.deliveryFee?.repeatQuantity ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} />
													<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 999,999,990</span>
												</td>
											</tr>
										)} */}
										<tr>
											<th>배송비 결제 방식 코드<span className="burgundy">*</span></th>
											<td>
												
												<select name={"originProduct.deliveryInfo.deliveryFee.deliveryFeePayType"} className="basic-input" style={{width: "200px"}} onChange={handleDataChange} value={data?.originProduct?.deliveryInfo?.deliveryFee?.deliveryFeePayType}>
													<option value="">선택하세요.</option>
													<option value={"COLLECT"}>착불</option>
													<option value={"PREPAID"}>선결제</option>
													<option value={"COLLECT_OR_PREPAID"}>착불 또는 선결제</option>
												</select>
											</td>
										</tr>
									</tbody>
								</table>

								<h2>클레임(반품/교환)</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>반품 배송비<span className="burgundy">*</span></th>
											<td>
												<Float className="basic-input" name={"originProduct.deliveryInfo.claimDeliveryInfo.returnDeliveryFee"} value={data?.originProduct?.deliveryInfo?.claimDeliveryInfo?.returnDeliveryFee ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} maxVal={1000000} />
												<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 1,000,000</span>
											</td>
										</tr>
										<tr>
											<th>교환 배송비<span className="burgundy">*</span></th>
											<td>
												<Float className="basic-input" name={"originProduct.deliveryInfo.claimDeliveryInfo.exchangeDeliveryFee"} value={data?.originProduct?.deliveryInfo?.claimDeliveryInfo?.exchangeDeliveryFee ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} minVal={0} maxVal={1000000} />
												<span className="burgundy" style={{display: "inline-block", marginLeft: "10px"}}>※ 최대 1,000,000</span>
											</td>
										</tr>
									</tbody>
								</table>

								<h2>AS 정보</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>A/S 전화번호<span className="burgundy">*</span></th>
											<td>
												<BasicInput item={{col: "originProduct.detailAttribute.afterServiceInfo.afterServiceTelephoneNumber"}} value={data?.originProduct?.detailAttribute?.afterServiceInfo?.afterServiceTelephoneNumber} onChange={handleDataChange} width="" textAlign="left" />
											</td>
										</tr>
										<tr>
											<th>A/S 안내<span className="burgundy">*</span></th>
											<td>
												<BasicInput item={{col: "originProduct.detailAttribute.afterServiceInfo.afterServiceGuideContent"}} value={data?.originProduct?.detailAttribute?.afterServiceInfo?.afterServiceGuideContent} onChange={handleDataChange} width="" textAlign="left" />
											</td>
										</tr>
									</tbody>
								</table>

								<h2>구매 수량</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>최소 구매 수량</th>
											<td>
												<Float className="basic-input" name={"originProduct.detailAttribute.purchaseQuantityInfo.minPurchaseQuantity"} value={data?.originProduct?.detailAttribute?.purchaseQuantityInfo?.minPurchaseQuantity ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} />
											</td>
										</tr>
										<tr>
											<th>1인 최대 구매 수량</th>
											<td>
												<Float className="basic-input" name={"originProduct.detailAttribute.purchaseQuantityInfo.maxPurchaseQuantityPerId"} value={data?.originProduct?.detailAttribute?.purchaseQuantityInfo?.maxPurchaseQuantityPerId ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} />
											</td>
										</tr>
										<tr>
											<th>1회 최대 구매 수량</th>
											<td>
												<Float className="basic-input" name={"originProduct.detailAttribute.purchaseQuantityInfo.maxPurchaseQuantityPerOrder"} value={data?.originProduct?.detailAttribute?.purchaseQuantityInfo?.maxPurchaseQuantityPerOrder ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left", display: "inline-block"}} addComma={true} />
											</td>
										</tr>
									</tbody>
								</table>

								<h2>원산지</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>원산지 상세 지역 코드<span className="burgundy">*</span></th>
											<td>
												<CommonCodeSelect
													item={{col: "originProduct.detailAttribute.originAreaInfo.originAreaCode"}} 
													onChange={handleDataChange} 
													value={data?.originProduct?.detailAttribute?.originAreaInfo?.originAreaCode} 
													defaultLabel="선택하세요" 
													grpCd="ORIGIN_AREA" 
													width={"250px"} 
												/>
											</td>
										</tr>
										{data?.originProduct?.detailAttribute?.originAreaInfo?.originAreaCode === "02" && (
											// 수입산인 경우 필수
											<tr>
												<th>수입사명<span className="burgundy">*</span></th>
												<td>
													<BasicInput item={{col: "originProduct.detailAttribute.originAreaInfo.importer"}} value={data?.originProduct?.detailAttribute?.originAreaInfo?.importer} onChange={handleDataChange} width="" textAlign="left" />
												</td>
											</tr>
										)}
										{data?.originProduct?.detailAttribute?.originAreaInfo?.originAreaCode === "04" && (
											// 기타-직접입력인 경우 필수
											<tr>
												<th>원산지 정보 직접 입력<span className="burgundy">*</span></th>
												<td>
													<BasicInput item={{col: "originProduct.detailAttribute.originAreaInfo.content"}} value={data?.originProduct?.detailAttribute?.originAreaInfo?.content} onChange={handleDataChange} width="" textAlign="left" />
												</td>
											</tr>
										)}
										<tr>
											<th>복수 원산지 여부</th>
											<td>
												<select name={"originProduct.detailAttribute.originAreaInfo.plural"} className="basic-input" style={{width: "250px"}} onChange={handleDataChange} value={data?.originProduct?.detailAttribute?.originAreaInfo?.plural}>
													<option value="">선택하세요.</option>
													<option value={true}>예</option>
													<option value={false}>아니오</option>
												</select>
											</td>
										</tr>
									</tbody>
								</table>

								<h2>추가 상품</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>정렬 방식<span className="burgundy">*</span></th>
											<td>
												<CommonCodeSelect
													item={{col: "originProduct.detailAttribute.supplementProductInfo.sortType"}} 
													onChange={handleDataChange} 
													value={data?.originProduct?.detailAttribute?.supplementProductInfo?.sortType} 
													defaultLabel="선택하세요" 
													grpCd="SUPPLEMENT_PRD_SORT_TYPE" 
													width={"250px"} 
												/>
											</td>
										</tr>
										<tr>
											<th>추가 상품</th>
											<td>
												<SupplementProductDisplay
													onClickAdd={() => showSupplementProductAddModal()}
													onClickMod={(idx) => showSupplementProductModModal(idx)}
													onClickDel={(idx) => delSupplementProduct(idx)}
													supplementProducts={data?.originProduct?.detailAttribute?.supplementProductInfo?.supplementProducts}
												/>
											</td>
										</tr>
									</tbody>
								</table>
								
								<h2>기타</h2>
								<table className="table-styled">
									<colgroup>
										<col width="150"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>부가세 타입 <span className="burgundy">*</span></th>
											<td>
												<CommonCodeSelect
													item={{col: "originProduct.detailAttribute.taxType"}} 
													onChange={handleDataChange} 
													value={data?.originProduct?.detailAttribute?.taxType} 
													defaultLabel="선택하세요" 
													grpCd="TAX_TYPE" 
													width={"250px"} 
												/>
											</td>
										</tr>
										<tr>
											<th>미성년자 구매 가능 여부<span className="burgundy">*</span></th>
											<td>
												<select name={"originProduct.detailAttribute.minorPurchasable"} className="basic-input" style={{width: "250px"}} onChange={handleDataChange} value={data?.originProduct?.detailAttribute?.minorPurchasable}>
													<option value="">선택하세요.</option>
													<option value={true}>가능</option>
													<option value={false}>불가</option>
												</select>
											</td>
										</tr>
										<tr>
											<th>맞춤 제작 상품 여부</th>
											<td>
												<select name={"originProduct.detailAttribute.customProductYn"} className="basic-input" style={{width: "250px"}} onChange={handleDataChange} value={data?.originProduct?.detailAttribute?.customProductYn}>
													<option value="">선택하세요.</option>
													<option value={true}>예</option>
													<option value={false}>아니오</option>
												</select>
											</td>
										</tr>
										<tr>
											<th>자체 제작 상품 여부</th>
											<td>
												<select name={"originProduct.detailAttribute.itselfProductionProductYn"} className="basic-input" style={{width: "250px"}} onChange={handleDataChange} value={data?.originProduct?.detailAttribute?.itselfProductionProductYn}>
													<option value="">선택하세요.</option>
													<option value={true}>예</option>
													<option value={false}>아니오</option>
												</select>
												<br/>
												<span className="burgundy">※ 미입력시 아니오</span>
											</td>
										</tr>
									</tbody>
								</table>

								<h2>상품정보 제공 고시</h2>
								<span className="burgundy">※ 미 입력시 "상품 상세 참조" 로 등록 됩니다.</span>
								<table className="table-styled">
									<colgroup>
										<col width="250"/>
										<col width="*"/>
									</colgroup>
									<tbody>
										<tr>
											<th>제품하자/오배송에 따른 청약 철회 조항</th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.returnCostReason"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.returnCostReason}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>제품하자가 아닌 소비자의 단순변심에 따른 청약철회가 불가능한 경우 그 구체적 사유와 근거</th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.noRefundReason"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.noRefundReason}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>재화 등의 교환ㆍ반품ㆍ보증 조건 및 품질 보증 기준</th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.qualityAssuranceStandard"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.qualityAssuranceStandard}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>대금을 환불받기 위한 방법과 환불이 지연될 경우 지연배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적인 조건·절차</th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.compensationProcedure"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.compensationProcedure}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>소비자피해보상의 처리, 재화 등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁 처리에 관한 사항</th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.troubleShootingContents"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.troubleShootingContents}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>품명 <span className="burgundy">*</span></th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.itemName"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.itemName}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>모델명 <span className="burgundy">*</span></th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.modelName"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.modelName}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>제조자(사) <span className="burgundy">*</span></th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.manufacturer"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.manufacturer}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
										<tr>
											<th>소비자 상담 전화번호 <span className="burgundy">*</span></th>
											<td>
												<BasicInput
													item={{col: "originProduct.detailAttribute.productInfoProvidedNotice.etc.customerServicePhoneNumber"}}
													value={data?.originProduct?.detailAttribute?.productInfoProvidedNotice?.etc?.customerServicePhoneNumber}
													onChange={handleDataChange}
													textAlign="left"
												/>
											</td>
										</tr>
									</tbody>
								</table>
								
							</div>

						</div>

						<div className="me-modal-footer mg-t-10 mg-b-20">
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={onClose} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={onClickOk} style={{width: "100%"}} />
								{/* <BasicButton label="테스트" className="btn-save" onClick={onClickTest} style={{width: "100%"}} /> */}

							</div>
						</div>

					</div>

				</div>
			</div>
			
			{/* 추가 상품 등록 */}
			<SupplementProductAddModModal
				isOpen={isOpenSupplementProductAddModal}
				initData={{}}
				initMode={"add"}
				existsGroupName={getExistsSupplementProductGroupName()}
				returnData={addSupplementProduct}
				onClose={()=> setIsOpenSupplementProductAddModal(false)}
				title="추가 상품 등록"
			/>
			{/* 추가 상품 수정 */}
			<SupplementProductAddModModal
				isOpen={isOpenSupplementProductModModal}
				initData={modInitData}
				initMode={"mod"}
				existsGroupName={getExistsSupplementProductGroupName(modInitData?.groupName)}
				returnData={modSupplementProduct}
				onClose={()=> setIsOpenSupplementProductModModal(false)}
				title="추가 상품 수정"
			/>
		</ReactModal>
	);
}

export default ProductAddModModal;
